export default __webpack_public_path__ + "static/media/morocco10.a79b7626.jpg";